import { component } from 'picoapp'
import { fetchCart, interceptCartJSON } from '@/lib/cart.js';

export default component((node, ctx) => {

  const commaSeparatedIDs = node.dataset.products;
  
  node.addEventListener('click', addAll);

  function addAll(e) {
    e.preventDefault();
    
    Shopify.queue = [];

    var newArray = commaSeparatedIDs.split(',');
    for (var i = 0; i < newArray.length; i++) {
      Shopify.queue.push(newArray[i]);
    }

    Shopify.moveAlong = function() {

      if (Shopify.queue.length) {
        var id = Shopify.queue.shift();


        fetch('/cart/add.js', {
          method: 'POST',
          credentials: 'include',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ id: id, quantity: 1 })
        }).then(r => {
          Shopify.moveAlong();
        });

      } else {

        fetchCart().then(cart => {

          // cart = interceptCartJSON(cart);

          ctx.hydrate({ cart: cart })
          ctx.emit('cart:updated')
          ctx.emit('cart:toggle', state => {
            return { cartOpen: 1 }
          })

          // return { item, cart }
        })

      }
    };

    Shopify.moveAlong();
  }

})
